// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sbyA9","right":"styles_right__GzxEu"};